import { AllTabsData, DetailsData } from './employee-overview.domain';

// @ts-ignore
export let TabsData: AllTabsData;
TabsData = {
  tabOne: {
    columns: [
      {
        field: 'companyId',
        label: 'Installateur-ID',
        width: '13%',
      },
      {
        field: 'name',
        label: 'Name',
        width: '16%',
      },
      {
        field: 'companyName',
        label: 'Firma',
        width: '13%',
      },
      {
        field: 'address',
        label: 'Adresse',
        width: '20%',
      },
      {
        field: 'telephone',
        label: 'Telefon',
        width: '10%',
      },
      {
        field: 'dateOfExpiry',
        label: 'Konzession bis',
        width: '14%',
      },
      {
        field: 'permissions',
        label: 'Permissions',
        width: '12%',
      },
      // {
      //   field: 'viewDetails',
      //   label: 'Antragsverfahren',
      //   width: '12%',
      // },
    ],
    data: [],
    pageTitle: 'Angemeldete Installateure',
    tabTitle: 'ANGEMELDETE INSTALLATEURE',
  },
  tabTwo: {
    columns: [
      {
        field: 'companyId',
        label: 'Installateur-ID',
        width: '11%',
      },
      {
        field: 'name',
        label: 'Name',
        width: '16%',
      },
      {
        field: 'companyName',
        label: 'Firma',
        width: '18%',
      },
      {
        field: 'address',
        label: 'Adresse',
        width: '20%',
      },
      // {
      //   field: 'networkOperator',
      //   label: 'Eingetragen bei',
      //   width: '14%',
      // },
      {
        field: 'telephone',
        label: 'Telefon',
        width: '10%',
      },
      {
        field: 'dateOfExpiry',
        label: 'Konzession bis',
        width: '13%',
      },
      {
        field: 'permissions',
        label: 'Permissions',
        width: '12%',
      },
    ],
    data: [],
    pageTitle: 'Angemeldete Gast-Installateure',
    tabTitle: 'ANGEMELDETE GAST-INSTALLATEURE',
  },
  tabThree: {
    columns: [
      {
        field: 'technicianId',
        label: 'Installateur-ID',
        width: '12%',
      },
      {
        field: 'name',
        label: 'Name',
        width: '17%',
      },
      {
        field: 'companyName',
        label: 'Firma',
        width: '13%',
      },
      {
        field: 'address',
        label: 'Adresse',
        width: '20%',
      },
      {
        field: 'telephone',
        label: 'Telefon',
        width: '10%',
      },
      {
        field: 'permissions',
        label: 'Permissions',
        width: '12%',
      },
      {
        field: 'status',
        label: 'Status',
        width: '10%',
      },
    ],
    data: [],
    pageTitle: 'Konzessionsantrage',
    tabTitle: 'KONZESSIONSANTRAG',
  },
  tabFour: {
    columns: [
      {
        field: 'technicianId',
        label: 'Installateur-ID',
        width: '13%',
      },
      {
        field: 'name',
        label: 'Name',
        width: '16%',
      },
      {
        field: 'companyName',
        label: 'Firma',
        width: '13%',
      },
      {
        field: 'address',
        label: 'Adresse',
        width: '20%',
      },
      {
        field: 'telephone',
        label: 'Telefon',
        width: '10%',
      },
      {
        field: 'dateOfExpiry',
        label: 'Konzession bis',
        width: '14%',
      },
      {
        field: 'permissions',
        label: 'Permissions',
        width: '12%',
      },
    ],
    data: [],
    pageTitle: 'Abgelehnte Konzessionsanträge',
    tabTitle: 'ABGELEHNTE KONZESSIONSANTRÄGE',
  },
  tabFive: {
    columns: [
      {
        field: 'companyId',
        label: 'Kehrbezirksnummer',
        width: '17%',
      },
      {
        field: 'name',
        label: 'Name',
        width: '17%',
      },
      {
        field: 'address',
        label: 'Adresse',
        width: '20%',
      },
      {
        field: 'telephone',
        label: 'Telefon',
        width: '10%',
      },
      {
        field: 'email',
        label: 'E-Mail',
        width: '17%',
      },
    ],
    data: [],
    pageTitle: 'Registered Chimney Sweepers',
    tabTitle: 'REGISTERED CHIMNEY SWEEPERS',
  },
};

export const DetailsPageData: DetailsData = {
  leftPanel: [
    {
      id: 'company-documents',
      section: 'Pflichtdokumente Unternehmen',
      data: [
        {
          field: 'business-registration',
          label: 'Gewerbeanmeldung',
          name: 'business_registration',
        },
        {
          field: 'commercial-register',
          label: 'Eintragung Handelsregister',
          name: 'entry_in_trade_register',
        },
        {
          field: 'registration-hwk',
          label: 'Eintragung HWK',
          name: 'entry_at_chamber_of_handicrafts',
        },
        {
          field: 'liability-proof',
          label: 'Nachweis Haftpflicht',
          name: 'proof_of_indemnity_insurance',
        },
      ],
    },
    {
      id: 'installer-documents',
      section: 'Pflichtdokumente Installateur',
      data: [
        {
          field: 'qualification-proof',
          label: 'Qualifikationsnachweis',
          name: 'proof_of_qualification',
        },
        {
          field: 'expertise-proof',
          label: 'Sachkundenachweis',
          name: 'proof_of_expertise',
        },
        {
          field: 'employment-proof',
          label: 'Anstellungsvertrag',
          name: 'proof_of_contract',
        },
      ],
    },
  ],
  rightPanel: [
    {
      id: 'network-permissions',
      section: 'Berechtigungen Netzanschluss',
      data: [
        {
          field: 'power',
          label: 'Strom',
        },
        {
          field: 'gas',
          label: 'Gas',
        },
        {
          field: 'water',
          label: 'Wasser',
        },
        {
          field: 'heating',
          label: 'Fernwärme',
        },
      ],
    },
    {
      id: 'licensing',
      section: 'Konzessionserteilung',
      data: [
        {
          field: 'permissionGranted',
          label: 'Zulassung erteilt',
        },
        {
          field: 'permissionGrantedUntil',
          label: 'Zulassung bis',
        },
      ],
    },
  ],
};

export const OverviewKeys: {
  [key: string]: string;
} = {
  TabOne: 'tabOne',
  TabTwo: 'tabTwo',
  TabThree: 'tabThree',
  TabFour: 'tabFour',
  TabFive: 'tabFive',
};
